module.exports = __webpack_public_path__ + "img/press-bg-3.c2707f9a.svg";